var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.2997 14.21C25.9097 13.82 25.2797 13.82 24.8897 14.21L19.9997 19.09L15.1097 14.2C14.7197 13.81 14.0897 13.81 13.6997 14.2C13.3097 14.59 13.3097 15.22 13.6997 15.61L18.5897 20.5L13.6997 25.39C13.3097 25.78 13.3097 26.41 13.6997 26.8C14.0897 27.19 14.7197 27.19 15.1097 26.8L19.9997 21.91L24.8897 26.8C25.2797 27.19 25.9097 27.19 26.2997 26.8C26.6897 26.41 26.6897 25.78 26.2997 25.39L21.4097 20.5L26.2997 15.61C26.6797 15.23 26.6797 14.59 26.2997 14.21Z",
    fill: "#6E7191"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.36bd589f47d16358d99966516987ba27.svg";
export { ForwardRef as ReactComponent };